export enum ApprovalStatus {
  NONE = 0,
  ACTIVE = 1,
  FINALIZED = 2,
}

export enum ApprovalIndicator {
  NONE = 0,
  APPROVED = 1,
  PENDING = 2,
  REJECTED = 3,
}

export enum ApproverOption {
  OBSERVER = 0,
  OPTIONAL = 1,
  MANDATORY = 2,
  ALL_MEMBERS = 3,
  MAJORITY = 4,
}

export const APPROVER_OPTIONS = [
  ApproverOption.OPTIONAL,
  ApproverOption.MANDATORY,
  ApproverOption.ALL_MEMBERS,
  ApproverOption.MAJORITY,
] as const;
